export default {
    title: `Les essentiels`,
    subTitle: `L'activité économique vue par Alan Mudie, responsable de la stratégie d'investissement de Société Générale Private Banking.`,
    keyFigures: [
          {
            figure: 2000,
            suffix: `milliards`,
            content: `Apple a atteint une capitalisation boursière de 2 000 milliards de dollars le 19 août 2020, doublant ainsi sa valorisation en un peu plus de deux ans. C’est la première fois qu’une société cotée américaine atteint ce seuil.`,
            noCollapse: true,
        },

        {
            figure: 2067,
            suffix: `$`,
            content: `Après avoir dépassé sa plus haute valeur historique de septembre 2011 à 1 921 $ l’once, l’or a franchi la barre symbolique des 2 000 $ pour atteindre un nouveau sommet à 2 067 $ début août.`,
            noCollapse: true,
        },

        {
            prefix: `-`,
            figure: 27.8,
            figureDecimals: 1,
            suffix: `%`,
            content: `Au 2e trimestre 2020, l’économie japonaise a reculé de 27.8 % en taux annualisé par rapport au trimestre précédent. Il s’agit de la plus forte contraction jamais enregistrée par le pays, l’activité économique ayant été paralysée par la crise du coronavirus.`,
            source: `Source: <a href="http://www.cao.go.jp/index-e.html" target="_blank">cao.go.jp</a>`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 1000,
            suffix: `milliards`,
            content: `Si les autorités sanitaires maintiennent des politiques rigoureuses de gestion de la pandémie (distanciation sociale et quarantaine), les coûts supplémentaires pour les systèmes de santé sont estimés par le FMI entre 130 et 231 milliards de dollars dans le monde. Sans ces mesures, la facture supplémentaire pourrait monter entre 600 et 1 000 milliards de dollars, soit jusqu’à 1,2 % du PIB mondial.`,
            source: `Source: <a href="http://imf.org" target="_blank">imf.org</a>`,
            noCollapse: true,
        },
        {   
            figure: 99.9,
            figureDecimals: 1,
            suffix: `%`,
            content: `Selon l’agence américaine d’observation océanique et atmosphérique, il y a 75 % de chance que 2020 soit l’année la plus chaude depuis 1880, et 99,9 % de chance qu’elle soit parmi les cinq années les plus chaudes jamais enregistrées.`,
            source: `Source: <a href="http://iea.org" target="_blank">iea.org</a>`,
            noCollapse: true,
            noMarge: true,
        },

        {
            figure: 4,
            suffix: `millions`,
            content: `C’est le nombre moyen d’inscriptions hebdomadaires au chômage aux États-Unis entre mi-mars et fin mai (comparé à 220 000 en temps normal). La hausse du chômage a été très rapide, concentrant en seulement deux mois l’équivalent des pertes d’emplois étalées sur deux ans lors de la crise financière de 2008-2009.`,
            source: `Source: <a href="http://dol.gov" target="_blank">dol.gov</a>`,
            noCollapse: true,
        },

        {
            figure: 200,
            suffix: `milliards`,
            content: `Selon Refinitiv, spécialiste de données de marchés, c’est le montant des nouvelles émissions d’obligations durables à travers le monde au 2e semestre 2020, soit deux fois plus que le montant émis au 2e semestre 2018.`,
            noCollapse: true,
        },

        {
            figure: 7169,
            suffix: `milliards`,
            content: `Le bilan de la Réserve Fédérale (banque centrale des États-Unis) a atteint un nouveau record à 7 169 milliards de dollar en juin dernier, soit l’équivalent de 32 % du PIB américain.`,
            source: `Source: Federal Reserve `,
            noCollapse: true,
        },

    ]
};

